(function () {
  'use strict';

  /* ─── Utility ─── */
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); };

  /* --- Money format -------------------------------------------
     Matches {{ product.price | money }} exactly.
     Liquid pre-renders a known amount so JS extracts
     prefix/suffix with zero token-parsing complexity.
  ------------------------------------------------------------ */
  var PQ_MONEY_SAMPLE = window.pqHeaderConfig ? window.pqHeaderConfig.moneySample : '12,345.67';

  /* Price formatting rules (no guessing by size):
     - Numbers and integer strings are Shopify minor units (paise), as returned by
       /cart.js, /products/<handle>.js, /recommendations/products.json and
       {{ product | json }}  ->  always divided by 100.
     - Strings with a decimal point ("1699.00") come from /search/suggest.json and
       /products.json and are already in rupees  ->  used as-is.
     - Strings that already carry a currency symbol were rendered by Liquid's
       | money filter  ->  only tidied, never divided again. */
  function pqRupees(num) {
    return '₹' + num.toLocaleString('en-IN', { minimumFractionDigits: (num % 1 ? 2 : 0), maximumFractionDigits: 2 });
  }
  function formatMoney(val) {
    if (val === null || val === undefined || val === '') return '';

    if (typeof val === 'number') {
      if (isNaN(val)) return '';
      return pqRupees(val / 100);
    }

    if (typeof val === 'string') {
      var strVal = val.trim();
      if (/₹|Rs/.test(strVal)) {
        return strVal.replace('Rs.', '₹').replace('Rs', '₹').replace(/\.00(?!\d)/, '');
      }
      var clean = strVal.replace(/,/g, '');
      if (/^-?\d+$/.test(clean)) return pqRupees(parseInt(clean, 10) / 100);
      if (/^-?\d*\.\d+$/.test(clean)) return pqRupees(parseFloat(clean));
      return strVal;
    }

    return String(val);
  }
  window.formatMoney = formatMoney;
  window.PQ_MONEY_SAMPLE = PQ_MONEY_SAMPLE;

  /* ─────────────────────────────────────────────────────
     STICKY HEADER — three modes + transparent handling
  ───────────────────────────────────────────────────── */
  var header       = $('#pq-header');
  var stickyMode   = header ? header.dataset.sticky : 'none';   // 'always' | 'scroll_up' | 'none'
  /* isTransparent checked live — slideshow may set this after page load */
  var isTransparent = false;
  var lastScrollY  = window.scrollY;
  var headerH      = header ? header.offsetHeight : 0;

  /* Set parent section height so content doesn't jump when header becomes fixed */
  function applyHeaderHeight() {
    if (!header) return;
    headerH = header.offsetHeight;
    var sectionWrap = header.closest('.shopify-section');
    if (sectionWrap && (stickyMode === 'always' || stickyMode === 'scroll_up')) {
      if (header.dataset.transparent !== 'true') {
        sectionWrap.style.height = headerH + 'px';
      }
    }
  }

  /* Unified scroll handler — sticky + transparent */
  function onHeaderScroll() {
    var y       = window.scrollY;
    var scrolled = y > 10;

    /* ── Scroll-up sticky ── */
    if (stickyMode === 'scroll_up') {
      if (y <= headerH) {
        /* At top: always show */
        header.classList.add('pq-header--visible');
        document.documentElement.style.setProperty('--pq-header-offset', headerH + 'px');
      } else if (y < lastScrollY) {
        /* Scrolling UP: reveal */
        header.classList.add('pq-header--visible');
        document.documentElement.style.setProperty('--pq-header-offset', headerH + 'px');
      } else {
        /* Scrolling DOWN: hide */
        header.classList.remove('pq-header--visible');
        document.documentElement.style.setProperty('--pq-header-offset', '0px');
      }
    }

    header.classList.toggle('pq-header--scrolled', scrolled);
    
    isTransparent = header.dataset.transparent === 'true';
    if (isTransparent) {
      if (scrolled) {
        header.classList.remove('pq-header--transparent');
      } else {
        header.classList.add('pq-header--transparent');
      }
      /* DO NOT dynamically re-apply body pad on transparent headers.
         Transparent headers sit over full-width sections. Pushing the body down
         causes aggressive glitching drops of slideshow content. */
    }

    lastScrollY = y;
  }

  /* Init */
  if (stickyMode === 'always' || stickyMode === 'scroll_up') {
    applyHeaderHeight();
    window.addEventListener('resize', applyHeaderHeight, { passive: true });

    /* scroll_up: show immediately at top */
    if (stickyMode === 'scroll_up') {
      header.classList.add('pq-header--visible');
    }
  }

  window.addEventListener('scroll', onHeaderScroll, { passive: true });
  onHeaderScroll(); /* run once on load */

  /* ─────────────────────────────────────────────────────
     OVERLAY / DRAWER MANAGEMENT
  ───────────────────────────────────────────────────── */
  var backdrop = $('#pq-backdrop');
  var activeDrawer = null;
  var bodyScrollY = 0;

  function lockScroll() {
    bodyScrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + bodyScrollY + 'px';
    document.body.style.width = '100%';
  }

  function unlockScroll() {
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, bodyScrollY);
  }

  function openDrawer(drawer, triggerId) {
    if (activeDrawer && activeDrawer !== drawer) {
      closeDrawer(activeDrawer, false);
    }
    activeDrawer = drawer;
    drawer.classList.add('is-open');
    backdrop.classList.add('is-visible');
    lockScroll();
    drawer.setAttribute('aria-hidden', 'false');
    if (triggerId) {
      var t = $('#' + triggerId);
      if (t) t.setAttribute('aria-expanded', 'true');
    }
    // Focus first focusable element
    setTimeout(function () {
      var focusable = drawer.querySelector('button, input, a, [tabindex]:not([tabindex="-1"])');
      if (focusable) focusable.focus();
    }, 340);
  }

  function closeDrawer(drawer, doUnlock, triggerId) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-visible');
    drawer.setAttribute('aria-hidden', 'true');
    if (triggerId) {
      var t = $('#' + triggerId);
      if (t) t.setAttribute('aria-expanded', 'false');
    }
    if (doUnlock !== false) unlockScroll();
    if (activeDrawer === drawer) activeDrawer = null;

    if (drawer.id === 'pq-mobile-drawer') {
      setTimeout(function() {
        $$('.pq-mobile-panel.is-open', drawer).forEach(function(p) {
          p.classList.remove('is-open');
        });
      }, 400);
    }
  }
  window.openDrawer = openDrawer;
  window.closeDrawer = closeDrawer;

  // Close on backdrop click
  backdrop.addEventListener('click', function () {
    if ($('#pq-search-drawer').classList.contains('is-open')) {
      closeSearch();
    }
    if (activeDrawer) closeDrawer(activeDrawer, true);
  });

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (activeDrawer) closeDrawer(activeDrawer, true);
      if ($('#pq-search-drawer').classList.contains('is-open')) closeSearch();
    }
  });

  /* ─────────────────────────────────────────────────────
     SEARCH DRAWER
  ───────────────────────────────────────────────────── */
  var searchDrawer    = $('#pq-search-drawer');
  var searchInput     = $('#pq-search-input');
  var searchResults   = $('#pq-search-results');
  var searchFeatured  = $('#pq-search-featured');
  var searchFeatGrid  = $('#pq-search-featured-grid');
  var searchTriggers  = $$('.js-pq-search-trigger');
  var searchTimer     = null;
  var lastQuery       = '';
  var featRendered    = false;

  /* Render the featured collection grid (runs once, cached) */
  function renderFeatured() {
    if (featRendered || !searchFeatGrid) return;
    var products = window.PQ_SEARCH_COLLECTION || [];
    if (!products.length) return;

    var html = '';
    products.forEach(function (p) {
      var img = p.image
        ? '<img src="' + p.image + '" alt="' + p.title + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;">'
        : '';
      var priceHtml = '';
      if (p.price) {
        if (p.compare_at_price) {
          priceHtml = '<div class="pq-search-featured__price">'
            + '<span class="pq-search-price--sale">' + p.price + '</span>'
            + '<span class="pq-search-price--compare">' + p.compare_at_price + '</span>'
            + '</div>';
        } else {
          priceHtml = '<div class="pq-search-featured__price"><span class="pq-search-price--regular">' + p.price + '</span></div>';
        }
      }
      html += '<a class="pq-search-featured__item" href="' + p.url + '">'
        + '<div class="pq-search-featured__img-wrap">' + img + '</div>'
        + '<div class="pq-search-featured__title">' + p.title + '</div>'
        + priceHtml
        + '</a>';
    });
    searchFeatGrid.innerHTML = html;
    featRendered = true;

    /* Staggered reveal */
    $$('.pq-search-featured__item', searchFeatGrid).forEach(function (el, i) {
      setTimeout(function () { el.classList.add('is-visible'); }, 40 + i * 40);
    });
  }

  function showFeatured() {
    if (!searchFeatured) return;
    var products = window.PQ_SEARCH_COLLECTION || [];
    if (!products.length) return;
    renderFeatured();
    searchFeatured.style.display = 'block';
  }

  function hideFeatured() {
    if (searchFeatured) searchFeatured.style.display = 'none';
  }

  function openSearch() {
    if (!searchDrawer || !header) return;
    if (activeDrawer) closeDrawer(activeDrawer, true);
    // Force header to solid color state
    header.classList.add('is-search-open');
    searchDrawer.classList.add('is-open');
    /* Search is an inline dropdown — no backdrop darkening, no scroll lock.
       This keeps the page visible and feels like a premium inline panel. */
    searchTriggers.forEach(function(el) { el.setAttribute('aria-expanded', 'true'); });
    /* Show featured collection immediately on open */
    showFeatured();
    /* Focus input without scrolling page */
    if (searchInput) setTimeout(function () { searchInput.focus({ preventScroll: true }); }, 200);
  }

  function closeSearch() {
    if (!searchDrawer) return;
    searchDrawer.classList.remove('is-open');
    // Remove solid color state from header
    header.classList.remove('is-search-open');
    /* No backdrop/scroll-lock was applied on open, so nothing to undo here */
    searchTriggers.forEach(function(el) { el.setAttribute('aria-expanded', 'false'); });
    lastQuery = '';
    if (searchInput) searchInput.value = '';
    /* Defer DOM cleanup until after CSS transition finishes */
    setTimeout(function () {
      if (searchResults) searchResults.innerHTML = '';
      hideFeatured();
    }, 320);
  }

  searchTriggers.forEach(function(btn) {
    btn.addEventListener('click', openSearch);
  });
  var searchCloseBtn = $('#pq-search-close');
  if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearch);

  /* Predictive search — hide featured while typing, show again if cleared */
  searchInput.addEventListener('input', function () {
    var q = this.value.trim();
    clearTimeout(searchTimer);
    if (!q || q.length < 2) {
      searchResults.innerHTML = '';
      lastQuery = '';
      showFeatured();   /* cleared — show featured again */
      return;
    }
    hideFeatured();     /* typing — hide featured, show results */
    if (q === lastQuery) return;
    searchTimer = setTimeout(function () {
      lastQuery = q;
      runSearch(q);
    }, 320);
  });

  function runSearch(q) {
    searchResults.innerHTML = '<p class="pq-search-loading-msg">Searching&hellip;</p>';
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide';
    fetch(url)
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderSearchResults(products, q);
      })
      .catch(function () {
        searchResults.innerHTML = '<p class="pq-search-empty-msg">No results found.</p>';
      });
  }

  function renderSearchResults(products, q) {
    if (!products.length) {
      searchResults.innerHTML = '<p class="pq-search-empty-msg">No results for &ldquo;' + q + '&rdquo;</p>';
      return;
    }
    var html = '<div class="pq-search-results-grid">';
    products.forEach(function (p) {
      var priceStr = p.price ? formatMoney(p.price) : '';
      var compareStr = (p.compare_at_price && p.compare_at_price > p.price) ? formatMoney(p.compare_at_price) : '';
      if (!compareStr && p.compare_at_price_max && p.compare_at_price_max > p.price) {
        compareStr = formatMoney(p.compare_at_price_max);
      }
      if (!compareStr && p.compare_at_price_min && p.compare_at_price_min > p.price) {
        compareStr = formatMoney(p.compare_at_price_min);
      }

      var priceHtml = '';
      if (compareStr) {
        priceHtml = '<div class="pq-search-result-item__price-wrap">'
          + '<span class="pq-search-price--sale">' + priceStr + '</span>'
          + '<span class="pq-search-price--compare">' + compareStr + '</span>'
          + '</div>';
      } else if (priceStr) {
        priceHtml = '<div class="pq-search-result-item__price-wrap"><span class="pq-search-price--regular">' + priceStr + '</span></div>';
      }

      /* featured_image can be a string URL or an object with .url */
      var rawImg = p.featured_image;
      var imgUrl = '';
      if (rawImg) {
        imgUrl = (typeof rawImg === 'object' && rawImg.url) ? rawImg.url : String(rawImg);
        /* Ensure https and add Shopify CDN width param */
        if (imgUrl.indexOf('//') === 0) imgUrl = 'https:' + imgUrl;
        /* Add size if no existing size param */
        if (imgUrl.indexOf('?') === -1) {
          imgUrl = imgUrl + '?width=400';
        } else if (imgUrl.indexOf('width=') === -1) {
          imgUrl = imgUrl + '&width=400';
        }
      }
      var img = imgUrl
        ? '<img src="' + imgUrl + '" alt="' + p.title + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;">'
        : '';
      html += '<a class="pq-search-result-item" href="' + p.url + '">'
        + '<div class="pq-search-result-item__img">' + img + '</div>'
        + '<div class="pq-search-result-item__title">' + p.title + '</div>'
        + priceHtml
        + '</a>';
    });
    html += '</div>';
    searchResults.innerHTML = html;
    // Staggered reveal
    $$('.pq-search-result-item', searchResults).forEach(function (el, i) {
      setTimeout(function () { el.classList.add('is-visible'); }, 40 + i * 50);
    });
  }


  /* ─────────────────────────────────────────────────────
     CART DRAWER — Full AJAX
  ───────────────────────────────────────────────────── */
  /* ─── Cart Logic moved to pq-cart-drawer.liquid ─── */

  /* ─────────────────────────────────────────────────────
     MOBILE MENU DRAWER
  ───────────────────────────────────────────────────── */
  var mobileDrawer = $('#pq-mobile-drawer');

  $('#pq-mobile-open').addEventListener('click', function () {
    openDrawer(mobileDrawer, 'pq-mobile-open');
  });

  var mobileCloseBtn = $('#pq-mobile-close');
  if (mobileCloseBtn) {
    mobileCloseBtn.addEventListener('click', function () {
      closeDrawer(mobileDrawer, true, 'pq-mobile-open');
    });
  }

  /* Mobile Menu Panels Logic */
  var mainPanel = $('#pq-panel-main');

  $$('[data-open-panel]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var panelId = btn.getAttribute('data-open-panel');
      var targetPanel = $('#' + panelId);
      if (targetPanel) {
        targetPanel.classList.add('is-active');
        if (panelId.indexOf('sub-') === -1) {
           /* Level 1 open: hide main panel slightly */
           if (mainPanel) mainPanel.classList.add('is-hidden');
        }
      }
    });
  });

  $$('[data-close-panel]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var currentPanel = btn.closest('.pq-mobile-panel');
      if (currentPanel) {
        currentPanel.classList.remove('is-active');
        /* If we are closing the last active sub-panel, show main panel again */
        /* Use :not(.pq-mobile-panel--main) to ensure we don't count the main panel itself */
        var activeSubPanels = $$('.pq-mobile-panel.is-active:not(.pq-mobile-panel--main)');
        if (activeSubPanels.length === 0) {
          if (mainPanel) mainPanel.classList.remove('is-hidden');
        }
      }
    });
  });

  /* Reset all panels when drawer closes */
  function resetMobilePanels() {
    $$('.pq-mobile-panel').forEach(function(p) {
      p.classList.remove('is-active');
      p.classList.remove('is-hidden');
    });
    if (mainPanel) {
      mainPanel.classList.add('is-active');
      mainPanel.classList.remove('is-hidden');
    }
  }

  /* Hook reset into drawer close */
  if (mobileCloseBtn) {
    mobileCloseBtn.addEventListener('click', function () {
      setTimeout(resetMobilePanels, 400); /* delay until drawer is off-screen */
    });
  }
  /* Overlay close reset */
  var backdrop = $('#pq-backdrop');
  if (backdrop) {
    backdrop.addEventListener('click', function() {
       setTimeout(resetMobilePanels, 400);
    });
  }

  $$('[data-close-drawer]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      closeDrawer(mobileDrawer, true, 'pq-mobile-open');
    });
  });

  /* ─── Global Cart Add hook handled in pq-cart-drawer.liquid ─── */

  /* ─────────────────────────────────────────────────────
     REVEAL ON SCROLL (Préstique extraction guide)
  ───────────────────────────────────────────────────── */
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!prefersReduced && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });

    $$('[data-reveal]').forEach(function (el) { revealObserver.observe(el); });
  } else {
    $$('[data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ─── Wishlist Sync moved to pq-wishlist-header.liquid ─── */

  /* ─────────────────────────────────────────────────────
     INIT: Sync badge count from server on page load
  ───────────────────────────────────────────────────── */
  var initCount = window.pqHeaderConfig ? window.pqHeaderConfig.cartItemCount : 0;
  if (window.updateCartBadge) window.updateCartBadge(initCount);

})();
